import React from 'react';
import { Label } from '@/components/ui/label';
import { Check, Plus } from 'lucide-react';
import { AVAILABLE_AMENITIES } from './constants';

// Step 3: sport pickers + amenity grid.
export default function LocationFormAmenitiesTab({ formData, onToggleSport, onToggleAmenity }) {
  return (
    <div className="space-y-6 mt-4">
      <div>
        <Label className="uppercase text-xs font-bold text-muted-foreground mb-3 block">
          Supported Sports
        </Label>
        <div className="flex gap-3">
          {['badminton', 'pickleball'].map((sport) => {
            const active = formData.sports.includes(sport);
            return (
              <button
                key={sport}
                type="button"
                onClick={() => onToggleSport(sport)}
                className={`px-4 py-2 rounded-full border-2 transition-all capitalize ${
                  active
                    ? 'border-primary bg-primary text-primary-foreground'
                    : 'border-muted-foreground/30 hover:border-primary'
                }`}
              >
                {active && <Check className="w-4 h-4 inline mr-2" />}
                {sport}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <Label className="uppercase text-xs font-bold text-muted-foreground mb-3 block">
          Amenities
        </Label>
        <div className="grid grid-cols-2 gap-2">
          {AVAILABLE_AMENITIES.map((amenity) => {
            const active = formData.amenities.includes(amenity);
            return (
              <button
                key={amenity}
                type="button"
                onClick={() => onToggleAmenity(amenity)}
                className={`px-3 py-2 rounded-xl border text-left text-sm transition-all ${
                  active
                    ? 'border-primary bg-primary/10 text-primary'
                    : 'border-muted-foreground/30 hover:border-primary/50'
                }`}
              >
                {active ? (
                  <Check className="w-4 h-4 inline mr-2" />
                ) : (
                  <Plus className="w-4 h-4 inline mr-2 opacity-50" />
                )}
                {amenity}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
